import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { parameterizePath } from '../analyticsSanitization';
import { trackOpenPanelView } from './openpanel';

/** Track each route once, with patient IDs removed before delivery. */
export function useOpenPanelViews(): void {
  const { pathname } = useLocation();
  const previousPath = useRef<string | null>(null);

  useEffect(() => {
    if (previousPath.current === pathname) {
      return;
    }
    previousPath.current = pathname;
    trackOpenPanelView(parameterizePath(pathname));
  }, [pathname]);
}
